<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="直播名称">
                  <el-input style="width: 177px" v-model="queryForm.streamName"></el-input>
              </el-form-item>
              <el-form-item label="直播类型">
<!--                  <el-input  v-model="queryForm.streamType"></el-input>-->
                  <el-select style="width: 177px" v-model="queryForm.streamType" placeholder="请选择直播类型">
                      <el-option
                          v-for="item in streamTypeList"
                          :label="item.value"
                          :value="item.key"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseStreamList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduCourseStream"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduCourseStream(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseStream(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduCourseStreamList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduCourseStreamList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseStreamList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="streamName"
        label="直播名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="streamType"
        label="直播类型"
        width="180"
      >
          <template scope="scope">
              <span>{{ streamTypeList.find(e=>e.key === scope.row.streamType).value }}</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="startTime"
        label="开始时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="endTime"
        label="结束时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="streamTag"
        label="标签"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduCourseStream(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduCourseStream(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduCourseStream(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseStreamStates[eduCourseStreamState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduCourseStream"
          ref="eduCourseStreamForm"
          :rules="rules"
          label-width="90px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="直播名称"
            prop="streamName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseStream.streamName"
              :disabled="eduCourseStreamState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="直播类型"
            prop="streamType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseStream.streamType"-->
<!--              :disabled="eduCourseStreamState == 'check'"-->
<!--            ></el-input>-->
              <el-select :disabled="eduCourseStreamState == 'check'" style="width: 177px" v-model="eduCourseStream.streamType" placeholder="请选择直播类型">
                  <el-option
                      v-for="item in streamTypeList"
                      :label="item.value"
                      :value="item.key"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="开始时间"
            prop="startTime"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseStream.startTime"-->
<!--              :disabled="eduCourseStreamState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  v-model="eduCourseStream.startTime"
                  type="datetime"
                  :disabled="eduCourseStreamState == 'check'"
                  style="width: 177px;"
                  placeholder="选择开始时间"
                  size="small"
                  format='yyyy-MM-dd HH:mm:ss'
                  value-format='yyyy-MM-dd HH:mm:ss'>
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="结束时间"
            prop="endTime"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseStream.endTime"-->
<!--              :disabled="eduCourseStreamState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  v-model="eduCourseStream.endTime"
                  type="datetime"
                  :disabled="eduCourseStreamState == 'check'"
                  style="width: 177px;"
                  placeholder="选择结束时间"
                  size="small"
                  format='yyyy-MM-dd HH:mm:ss'
                  value-format='yyyy-MM-dd HH:mm:ss'>
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="标签"
            prop="streamTag"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseStream.streamTag"
              :disabled="eduCourseStreamState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseStream.sort"-->
<!--              :disabled="eduCourseStreamState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduCourseStreamState == 'check'"
                  v-model="eduCourseStream.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseStreamState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseStreamList();
                    this.getEduCourseStreamList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseStreamList();
                    this.getEduCourseStreamList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     streamName: '', //直播名称
                     streamType: '', //直播类型
                     startTime: '', //开始时间
                     endTime: '', //结束时间
                     streamTag: '', //标签
                     sort: '', //排序
                },
                streamTypeList: [],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseStreamState: 'add',
                eduCourseStreamStates: {
                    add: '新建房间',
                    check: '查看房间',
                    edit: '修改房间'
                },

                multipleSelection: [],
                eduCourseStreamList: [],
                eduCourseStream: {
                    id: '', //
                    streamName: '', //直播名称
                    streamType: '', //直播类型
                    startTime: '', //开始时间
                    endTime: '', //结束时间
                    streamTag: '', //标签
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    streamName: [{ required: true, message: '直播名称不能为空', trigger: 'blur' }],
                    streamType: [{ required: true, message: '直播类型不能为空', trigger: 'blur' }],
                    startTime: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
                    endTime: [{ required: true, message: '结束时间不能为空', trigger: 'blur' }],
                    streamTag: [{ required: true, message: '标签不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getEduCourseStreamList();
            this.getCourseTypeEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetEduCourseStreamList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseStreamList = [];
            },
            // 获取直播类型枚举
            getCourseTypeEnum(){
                get("/edu/utils/getEnum",{
                    enumType: "stream_type"
                }).then((res)=>{
                    if(res.success){
                        this.streamTypeList = res.enumList
                    }
                })
            },
            resetDialog() {
                this.eduCourseStreamState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      streamName: '', //直播名称
                      streamType: '', //直播类型
                      startTime: '', //开始时间
                      endTime: '', //结束时间
                      streamTag: '', //标签
                      sort: '', //排序
                };
                this.getEduCourseStreamList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseStream = {
                      id: '', //
                      streamName: '', //直播名称
                      streamType: '', //直播类型
                      startTime: '', //开始时间
                      endTime: '', //结束时间
                      streamTag: '', //标签
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduCourseStreamState == 'add') {
                    this.$refs.eduCourseStreamForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursestream/add`,{ ...this.eduCourseStream }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseStreamList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseStreamState == 'edit') {
                    this.$refs.eduCourseStreamForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursestream/edit`,{ ...this.eduCourseStream }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseStreamList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseStream() {
                this.showDialog = true;
                this.eduCourseStreamState = 'add';
            },
            checkEduCourseStream(eduCourseStreamId) {
                console.log(eduCourseStreamId);
                this.currentEduCourseStreamId = eduCourseStreamId;

                this.getEduCourseStreamById();
                this.showDialog = true;
                this.eduCourseStreamState = 'check';
            },
            editEduCourseStream(eduCourseStreamId) {
                console.log('eduCourseStream', eduCourseStreamId);
                if (eduCourseStreamId) {
                    this.currentEduCourseStreamId = eduCourseStreamId;
                    this.getEduCourseStreamById();
                } else {
                    this.eduCourseStream = { ...this.eduCourseStream, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseStreamState = 'edit';
            },
            deleteEduCourseStream(eduCourseStreamId) {
                let ids = '';
                if (eduCourseStreamId) {
                    ids = eduCourseStreamId;
                } else {
                    ids = this.multipleSelection.map((eduCourseStream) => eduCourseStream.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursestream/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseStreamList();
                                this.getEduCourseStreamList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseStreamList() {
                this.resetEduCourseStreamList();
                this.getEduCourseStreamList();
            },
            getEduCourseStreamList(query = {}) {
                this.loading = true;
                get(`/edu/coursestream/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseStreamList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseStreamById() {
                get(`/edu/coursestream/get`,{ id: this.currentEduCourseStreamId }).then((res) =>{
                    if(res.success){
                      this.eduCourseStream = { ...this.eduCourseStream, ...res.eduCourseStream };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseStreamList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursestream/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursestream/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursestream/importData`,formData);
              this.refreshEduCourseStreamList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseStreamList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseStreamList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>